import { render, staticRenderFns } from "./ActivateArticlesPage.vue?vue&type=template&id=0c677eff"
import script from "./ActivateArticlesPage.vue?vue&type=script&lang=js"
export * from "./ActivateArticlesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports